import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { AlertService } from '@carm/_core/alerts/services/alert.service';

@Component({
  selector: 'carm-forms-page',
  templateUrl: './forms-page.component.html',
  styleUrls: ['./forms-page.component.scss'],
})
export class FormsPageComponent implements OnInit, OnChanges {

  @Input()
  inLocalizedPageTitle: string;

  @Input()
  inLocalizedPageShortDescription: string;

  @Input()
  inBreadcrumbLevels: string;

  @Input()
  lastLoggedOut: Date;

  @Input()
  displayAlertsForPage: string;

  @Input()
  inHideTopTitleInfo: boolean;

  portalTitle: string;

  private alertKey: string | null = null;

  get resolvedDisplayAlertsForPage(): string {
    return this.displayAlertsForPage || this.alertKey || '';
  }

  constructor(private titleService: Title,
              protected translateService: TranslateService,
              private alertService: AlertService) { }

  ngOnInit(): void {
    this.alertService.alertKey$.subscribe(key => {
      this.alertKey = key;
    });
  }

  ngOnChanges(changes: SimpleChanges): void {

    this.portalTitle = this.translateService.instant('portalTitle');

    if(this.inLocalizedPageTitle) {
      this.titleService.setTitle(changes.inLocalizedPageTitle.currentValue +' - '+ this.portalTitle);
    } else {
      this.titleService.setTitle(this.portalTitle);
    }
  }
}
